module.exports = __webpack_public_path__ + "static/media/app02_eng.d075f337.png";